import React from 'react';

const AboutUs = () => {
    return (
        <div className="container mx-auto p-6">
            <h1 className="text-3xl font-bold mb-4">About Us</h1>
            <p>
                We are a passionate team providing digital services across rural and urban areas —
                including cable TV, internet, senior care, and more. Our vision is to create connected,
                empowered communities by blending tradition with technology.
            </p>
        </div>
    );
};

export default AboutUs;